export const OPEN_COMPLETE_PROFILE_AFTER_LOGIN_KEY =
  'open-complete-profile-after-sign-up';
